import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, Button, Divider } from '@mui/material';

const ProfileFooter = ({ currentUser }) => (
  <Box sx={{ mt: 5, textAlign: 'center', pb: 2 }}>
    <Divider sx={{ mb: 3, opacity: 0.5 }} />
    <Box
      component="img"
      src="/blackmount-logo.jpg"
      alt="Blackmount"
      sx={{ width: 28, height: 28, borderRadius: '50%', mb: 0.75, opacity: 0.6 }}
    />
    <Typography variant="body2" color="text.disabled" sx={{ mb: 0.5 }}>
      <Link to="/" style={{ color: 'inherit', textDecoration: 'none', fontWeight: 500 }}>
        Blackmount — memory for your browser
      </Link>
    </Typography>
    {!currentUser && (
      <Button
        variant="text"
        size="small"
        component={Link}
        to="/signup"
        sx={{ mt: 0.5, textTransform: 'none', fontWeight: 600, borderRadius: 3 }}
      >
        Get Started Free
      </Button>
    )}
  </Box>
);

export default ProfileFooter;
